module.exports = {"available":"available","booked":"Booked","occupied":"Occupied","booked-occupied":"Booked / Occupied","used":"used","until":"until","all-day":"all day","page_over_total":"page {page} of {total}","room-name":"room name","current-booking":"current booking","next-booking":"next booking","unknown":"unknown","floors":"floors","today":"today","no_bookings":"No bookings are scheduled for today.","no_information":"No information provided.","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Booked / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en.json
// module id = iD8h
// module chunks = 2